<script setup lang="ts">
const props = defineProps<{
  type: 'terms-and-conditions' | 'data-security' | 'imprint'
}>()
const { locale } = useI18n()
const path = computed(() => `/legal/${props.type}-${unref(locale).toLowerCase()}`)
const { data: doc } = await useAsyncData(
  `legal-${props.type}-${locale.value}`,
  () => queryCollection('legal').where('path', 'LIKE', path.value).first(),
  { server: false },
)
</script>

<template>
  <div
    id="legal-document"
    class="container--center"
  >
    <ContentRenderer v-if="doc" :value="doc" />
  </div>
</template>

<style lang="sass">
#legal-document
  h1
    margin-bottom: 24px !important
    line-height: 1.2 !important
</style>
